import { Injectable, InjectionToken } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserSessionService } from '@sg/common';
import { SgMenuGroup, SgMenuItem } from '@sg/ui-kit/core/src/lib/components/sg-menu/sg-menu.model';

export interface UserMenuService {
  getUserMenuGroups(): SgMenuGroup[];
  getUserSubtitle?(): string;
}

export const USER_MENU_SERVICE = new InjectionToken<UserMenuService>('UserMenuService');

@Injectable()
export abstract class BaseUserMenuService implements UserMenuService {
  //#region Ctor
  constructor(protected userSession: UserSessionService, protected dialog: MatDialog) {}
  //#endregion

  //#region Abstract Methods
  abstract getUserMenuGroups(): SgMenuGroup[];
  //#endregion

  //#region Protected Methods
  protected createDefaultActionsGroup(): SgMenuGroup {
    return {
      id: 'user-actions',
      label: '',
      items: this.createDefaultActionItems(),
    };
  }

  protected createDefaultActionItems(): SgMenuItem[] {
    return [
      {
        id: 'cookie-preferences',
        label: 'Cookie Preferences',
        icon: 'sg-cookie',
        action: () => this.openCookiePreferences(),
      },
      {
        id: 'logout',
        label: 'Log Out',
        icon: 'exit_to_app',
        action: () => this.logout(),
      },
    ];
  }

  protected async openCookiePreferences(): Promise<void> {
    try {
      const { CookiesSettingsDialogComponent } = await import('@sg/ui-kit/cookies-consent-dialog');
      this.dialog.open(CookiesSettingsDialogComponent, {
        width: '500px',
        disableClose: false,
      });
    } catch (error) {
      console.error('Failed to load cookie preferences dialog:', error);
    }
  }

  protected logout(): void {
    this.userSession.logout();
  }
  //#endregion
}
